import { CULTURE_SERIES, imgUrl } from "@/data/content";
import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export const CultureCard = ({ series, index }) => (
  <article
    data-testid={`culture-card-${index}`}
    className={`group border border-white/10 p-7 transition-colors hover:border-gold/60 ${series.image ? "flex min-h-[22rem] flex-col justify-end bg-cover bg-center sm:col-span-2" : ""}`}
    style={series.image ? { backgroundImage: `linear-gradient(to top, rgba(6,18,35,0.92), rgba(6,18,35,0.25)), url(${imgUrl(series.image, 1200)})` } : undefined}
  >
    <p className="font-serif text-sm text-gold">{String(index + 1).padStart(2, "0")}</p>
    <h3 className="mt-3 font-serif text-xl leading-snug text-white sm:text-2xl">{series.title}</h3>
    <p className="mt-3 max-w-md text-sm leading-relaxed text-white/65">{series.copy}</p>
  </article>
);

export default function Culture() {
  return (
    <section id="culture" data-testid="culture-section" className="grain bg-atlantic-deep py-24 lg:py-32">
      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          dark
          chapter="05"
          kicker="Culture and Memory"
          title="Culture Is Not Ornamental"
          copy="It is one of the strongest surviving records of connection between Africa, the Caribbean and their diasporas."
        />
        <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CULTURE_SERIES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.06}>
              <CultureCard series={s} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
